<template lang='pug'>
  #products.view
    base-modal#new-service.form(
      :show='show.new'
    )
      component(
        :is='`set-${type}`'
        :categories='categories'
        :account='account'
        :biz='biz'
        @set='show.new = false'
        @close='show.new = false'
        @categorize='show.new = false; $emit("categorize")'
      )
        template( v-slot:header ) {{ $t(`New ${type.charAt(0).toUpperCase() + type.slice(1)}`) }}

    base-modal#edit-service.form(
      :show='!!show.edit'
      @close='show.edit = false'
    )
      component(
        :is='`set-${type}`'
        :categories='categories'
        :account='account'
        :settable='editable'
        :biz='biz'
        @set='show.edit = false'
        @close='show.edit = false'
        @categorize='show.edit = false; $emit("categorize")'
      )
        template( v-slot:header ) {{ $t(`Edit ${type.charAt(0).toUpperCase() + type.slice(1)}`) }}
        template( v-slot:footer) {{ $t('Update') }}

    .items
      bf-flex.centered.add-button.actionable(
        v-if='account.merchant'
        @click.native='make'
      )
        bf-flex.centered.icon
          new-icon
        span {{ $t("ADD")}}
        
      bf-flex.item.actionable( 
        v-for='item in filtered' 
        @click.native='edit( item )' 
        :key='item.id' 
      )
        .delete( @click.stop='remove( item )' )
          delete-icon
        featured-image.image( :collection='collection' :doc='item' )
        .text
          h5.title {{ item.title }}
          p.desc {{ item.description }}
</template>

<script>
  import { View } from '@/mixins/view'
  import { Sellable } from '@/mixins/sellable'
  import SetProduct from '@/components/set-product'

  export default {
    name: 'products.view',

    mixins: [ View, Sellable ],

    components: {
      SetProduct
    },

    data() {
      return {
        type: 'product',
        collection: 'products',
      }
    }
  }

</script>

<style scoped lang='stylus'>
  .add-button
    width 100px
    font-weight bold
    font-size 1.2em
    background white
    padding 10px
    border 1px solid rgb(200 200 200)
    border-radius 5px
  .items
    .item
      background white
      border-radius 8px
      border 1px solid rgb( 240 240 240 )
      position relative
      box-shadow var(--shadow-card)
      overflow hidden
      margin 16px 0
      width 100%
      flex-flow row
      &:hover
        box-shadow var(--shadow-card-hover)
      .delete
        position absolute
        right 8px
        top 8px
        font-size 1.2em
      .image
        flex-grow 0
        flex-basis 0
        img
          display block
          width 100%
          height 100%
          object-fit cover
      .text
        padding 12px
        flex-grow 5
        flex-basis 0
        p
          font-size 1.2em
        .title
          padding-right 24px
</style>
